import { createTrackingUtils } from "..";
import { useEffect } from "react";
import { isOfMetaOrigin } from "utils/marketing-url-params";

const utils = createTrackingUtils({
  name: "flights_web_cat_homepage_header_update_www",
  stages: {
    homepage: 1,
    direct: 2,
    meta: 3
  },
  defaultStage: 1,
  goals: {},
  goalsWithValue: []
});

export function useTrackHomePageHeaderExpStages() {
  const isMeta = isOfMetaOrigin();

  useEffect(() => {
    utils.stages.homepage();

    if (isMeta) {
      utils.stages.meta();
    } else {
      utils.stages.direct();
    }
  }, [isMeta]);
}

export { utils as flights_web_cat_homepage_header_update_www };
